import { IPm } from 'APIPackage/KnmModule/interfaces/IPm';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';

import { IKnmPmForm } from '../interfaces/IKnmPmForm';

export const convertExampleWarningFormValuesToKnmData = (
  formAttachments: IKnmPmForm['exampleWarningAttachments'],
  exampleWarningData: IPm['exampleWarning'] | undefined,
): IPm['exampleWarning'] => {
  if (!formAttachments) {
    return null;
  }

  return {
    active: exampleWarningData?.active ?? null,
    attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(formAttachments),
    correlationToken: exampleWarningData?.correlationToken ?? null,
    description: exampleWarningData?.description ?? null,
    guid: exampleWarningData?.guid ?? null,
    type: exampleWarningData?.type ?? null,
  };
};
